import React, { useEffect, useState } from 'react';
import { Mic, MicOff, Phone, PhoneOff } from 'lucide-react';
import { useVoiceCall } from '../../context/VoiceCallContext';
import './voiceCallOverlay.css';

const formatDuration = seconds => `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

export default function VoiceCallOverlay() {
  const { status, call, error, muted, acceptCall, rejectCall, endCall, toggleMute } = useVoiceCall();
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (status !== 'active') {
      setDuration(0);
      return undefined;
    }
    const timer = window.setInterval(() => setDuration(value => value + 1), 1000);
    return () => window.clearInterval(timer);
  }, [status]);

  if (status === 'idle') return null;
  if (status === 'error' || status === 'ended') {
    return <div className={`voice-call-toast is-${status}`} role="status">{error || 'Appel terminé'}</div>;
  }

  const incoming = status === 'incoming';
  const personName = incoming ? call?.caller_name : call?.target_name;
  const statusLabel = incoming
    ? 'Appel vocal entrant'
    : status === 'ringing'
    ? 'Appel en cours…'
    : status === 'connecting'
    ? 'Connexion audio…'
    : formatDuration(duration);

  return (
    <aside className={`voice-call-panel is-${status}`} role={incoming ? 'alertdialog' : 'status'} aria-label={`${statusLabel} avec ${personName}`}>
      <span className="voice-call-avatar" aria-hidden="true"><Phone /></span>
      <div className="voice-call-copy"><small>{statusLabel}</small><strong>{personName}</strong></div>
      <div className="voice-call-actions">
        {incoming ? (
          <>
            <button type="button" className="voice-call-button is-decline" aria-label="Refuser l’appel" onClick={rejectCall}><PhoneOff /></button>
            <button type="button" className="voice-call-button is-accept" aria-label="Accepter l’appel" onClick={acceptCall}><Phone /></button>
          </>
        ) : (
          <>
            {(status === 'connecting' || status === 'active') && (
              <button type="button" className={`voice-call-button is-mute ${muted ? 'is-active' : ''}`} aria-label={muted ? 'Réactiver le microphone' : 'Couper le microphone'} onClick={toggleMute}>
                {muted ? <MicOff /> : <Mic />}
              </button>
            )}
            <button type="button" className="voice-call-button is-decline" aria-label="Raccrocher" onClick={endCall}><PhoneOff /></button>
          </>
        )}
      </div>
    </aside>
  );
}
